import React, { useState, useEffect } from "react";
import styles from "./Location.module.scss";
import { useForm, Controller } from "react-hook-form";
import { Country } from "country-state-city";
import { profileChangeLocation } from "../../../api/userApi";
import { useAuth } from "../../PrivateRoute/PrivateRoute";
import { useNotification } from "../../../contexts/NotificationToast";
import { useQueryClient } from "@tanstack/react-query";
import CustomSelect from "../../CustomSelect/CustomSelect";
import CustomInput from "../../CustomInput/CustomInput";
import CustomButton from "../../CustomButton/CustomButton";

const Location = () => {
  const { userData } = useAuth();
  const { showNotification } = useNotification();
  const queryClient = useQueryClient();

  const {
    control,
    handleSubmit,
    formState: { errors },
  } = useForm({
    defaultValues: {
      country: userData?.country || null,
      city: userData?.city || "",
      address: userData?.address || "Stradivari Ave",
      postalCode: userData?.postal_code || "33-321",
    },
  });

  const [countries, setCountriesList] = useState([]);

  useEffect(() => {
    const countries = Country.getAllCountries();
    setCountriesList(
      countries.map((country) => ({
        label: country.name,
        value: country.name,
      }))
    );
  }, []);

  const onSubmit = async (data) => {
    try {
      await profileChangeLocation(data);
      showNotification("Successfully changed", 200);
      queryClient.invalidateQueries(["authProfile"]);
    } catch (error) {
      showNotification("Error", 400);
    }
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <h2 className={styles.title}>Местоположение</h2>
      <div className={styles.infoContainer}>
        <div className={styles.infoItem}>
          <label className={styles.itemTitle}>Country</label>
          <Controller
            name="country"
            control={control}
            render={({ field }) => (
              <CustomSelect
                {...field}
                options={countries}
                onChange={(selectedOption) => {
                  field.onChange(selectedOption);
                }}
                placeholder="Enter страну"
              />
            )}
            rules={{ required: "Страна обязательна" }}
          />
        </div>

        <Controller
          name="city"
          control={control}
          render={({ field }) => (
            <CustomInput
              {...field}
              label="City"
              placeholder="Enter city name"
            />
          )}
          rules={{ required: "city обязателен" }}
        />

        <div className={styles.adressInfo}>
          <Controller
            name="address"
            control={control}
            render={({ field }) => (
              <CustomInput
                {...field}
                label="Street"
                placeholder="Enter street name"
              />
            )}
            rules={{ required: "Адрес обязателен" }}
          />

          <Controller
            name="postalCode"
            control={control}
            render={({ field }) => (
              <CustomInput
                {...field}
                label="Index"
                placeholder="Enter postal code"
              />
            )}
            rules={{ required: "Индекс обязателен" }}
          />
        </div>
        <CustomButton
          blue
          width="300px"
          className={styles.saveButton}
          type="submit"
        >
          Сохранить
        </CustomButton>
      </div>
    </form>
  );
};

export default Location;
